import axios from 'axios';

const LenderContactService = {
  async getLenderContact(contactId) {
    const response = await axios.get(`/lender_contact/${contactId}`);

    return response.data;
  },

  async createLenderContact(formValues) {
    const response = await axios.post('/lender_contact', formValues);

    return response.data;
  },

  async updateLenderContact({ contactId, formValues }) {
    const response = await axios.put(
      `/lender_contact/${contactId}`,
      formValues
    );

    return response.data;
  },

  async deleteLenderContact(contactId) {
    const response = await axios.delete(`/lender_contact/${contactId}`);

    return response.data;
  },
};

export default LenderContactService;
